import React, { useEffect, useRef, useState } from "react";
import Wrapper from "../utils/Wrapper";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import getFormatedDate from "../../utils/helperFunctions/formatedDate";
import sanitizeHtml from "../../utils/UI/sanitizeHtml";
import sizeCalculator from "../../utils/helperFunctions/sizeLabelCompiler";
import getFormatNumber from "../../utils/helperFunctions/getFormatedNumber";
export interface NewsCardProps {
  publisher?: string;
  title?: string;
  img?: string;
  date?: string;
  sentiment?: string;
  traffic?: number;
  description?: string;
  sourceIcon?: string;
  ave?: number;
  keywords?: Array<string>;
  country?: Array<string>;
  language?: string;
  mediaType: string;
  size?: object;
  length?: number;
  link?: string;
}

export const ArticleCard: React.FC<NewsCardProps> = ({
  publisher,
  title,
  img,
  date,
  sentiment,
  traffic = 0,
  description,
  sourceIcon,
  ave,
  keywords,
  country,
  language,
  mediaType,
  length = 0,
  link,
}) => {
  const innerHTMLref = useRef<HTMLParagraphElement | null>(null);
  const [textDescription, setTextDescription] = useState("");
  const [size, setSize] = useState<object>({});
  const [sentimentData, setSentimentData] = useState({
    value: "Negative",
    textColor: "text-print",
    chipColor:"#FFE8E8",
  });
  const navigate = useNavigate();

  const navigateWithData = (dataToSend: NewsCardProps) => {
    navigate("/dashboard/content/article-insight", { state: dataToSend });
  };

  const trafficLabelSwitch = (mediaType: string): string => {
    switch (mediaType) {
      case "digital":
        return "Traffic";
      case "radio":
        return "Listeners";
      case "tv":
        return "Viewers";
      case "print":
        return "Readers";
      default:
        return "Readers";
    }
  };

  const sentimentBG = (sentiment: string) => {
    switch (sentiment) {
      case "positive":
        return "text-radio";
      case "negative":
        return "text-print";
      case "neutral":
        return "text-tv";
      default:
        return "text-radio";
    }
  };
  const sentimentBGChip = (sentiment: string) => {
    switch (sentiment) {
      case "positive":
        return "#EEF8ED";
      case "negative":
        return "#FFE8E8";
      case "neutral":
        return "#E7EBFF";
      default:
        return "#E7EBFF";
    }
  };

  useEffect(() => {
    const text = sanitizeHtml(description || "");
    setTextDescription(text);
    setSize(sizeCalculator(mediaType, text, length));
  }, [description]);

  useEffect(() => {
    if (!sentiment) return;
    const sentimentValue = sentiment?.includes("ONLY")
      ? "Positive"
      : sentiment || "Negative";
    const textColor = sentimentBG(sentiment?.toLowerCase());
    const chipColor = sentimentBGChip(sentiment?.toLowerCase());
    setSentimentData({
      value: sentimentValue,
      textColor: textColor,
      chipColor: chipColor,
    });
  }, [sentiment]);

  return (
    <Wrapper
      customClass={" min-h-[461px] max-h-[461px] relative cursor-pointer"}
      insightCustomCSS="absolute bottom-[10px]"
      onClick={() =>
        navigateWithData({
          publisher,
          title,
          img,
          date,
          sentiment: sentimentData?.value,
          traffic,
          description: textDescription,
          sourceIcon,
          ave,
          keywords,
          country,
          language,
          mediaType,
          size,
          link,
        })
      }
    >
      <div className="mb-[18px] font-salara">
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-2">
            <span className="bg-[#FFED9E] text-black font-bold text-xs px-2 py-1 rounded-lg">
              {publisher}
            </span>
          </div>
          <img
            src={img}
            alt={title}
            className="w-full max-h-[155px] object-cover"
          />
          <span className="text-2xl md:font-bold font-semibold text-gray-800 font-poppins max-h-[64px] overflow-hidden">
            {title && title.length > 38 ? title?.slice(0, 42) + "..." : title}
          </span>
          <div className="flex flex-col gap-4">
            <p className="md:text-xs text-[10px] font-normal text-[#999999]">
              {date && getFormatedDate(date)}
            </p>
            <div className="flex justify-between items-center">
              <span
                className={`text-xs font-semibold px-2 py-1 rounded bg-[${sentimentData?.chipColor}] text-gray-600 px-2 py-1 rounded-lg`}
                style={{
                  backgroundColor: sentimentData?.chipColor,
                }}
              >
                Sentiment: <span
                className={`text-xs font-bold  ${sentimentData?.textColor}`}
              >
               {sentimentData?.value}
              </span>
              </span>
              
              <span className="text-xs font-bold bg-[#EDEDED] text-gray-600 px-2 py-1 rounded-lg">
                Estimated {trafficLabelSwitch(mediaType)}: {getFormatNumber(traffic)}
              </span>
            </div>
          </div>
        </div>
        <div className="mt-3 pt-2 border-t border-gray-200">
          <p className="text-[#1C1F22] text-xs ">
            {textDescription && textDescription?.length > 200
              ? textDescription?.slice(0, 200) + "..."
              : textDescription}
          </p>
        </div>
      </div>
    </Wrapper>
  );
};

export default ArticleCard;
